import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-proxy',
  standalone: true,
  imports: [],
  templateUrl: './proxy.component.html',
  styleUrls: ['./proxy.component.scss'],
})
export class ProxyComponent implements OnInit {
  ngOnInit(): void {
    this.loadGigyaOIDC();
  }

  loadGigyaOIDC() {
    let node = document.createElement('script');
    node.src = `https://cdns.gigya.com/js/gigya.oidc.js?apiKey=${environment.apiKey}`;
    node.type = 'text/javascript';
    node.lang = 'javascript';
    const config = {
      loginURL: `${window.location.origin}/login`,
      errorURL: `${window.location.origin}/OpErrorPage`,
      skipConsent: true,
    };
    node.innerText = JSON.stringify(config);
    document.head.appendChild(node);
  }
}
